import useAuth from '@/utils/useAuth'
import { PILOT_REGION_IDS } from '@/constants'

// Единый сторож разделения сервисов. Пользователей пилотных регионов
// уводим со старого сервиса на новый (photobinding-dev-v2), КРОМЕ маршрутов из
// белого списка (просмотр заявки целиком + общие заявки) — на них приходят по
// прямым ссылкам. Вся логика гейтинга собрана здесь, в одном месте; роутер лишь
// вызывает redirectPilotToNewService() в beforeEach.
//
// Пустой VUE_APP_NEW_SERVICE_URL (локальная разработка/тесты) полностью
// выключает редирект.

// Белый список — ИМЕНА маршрутов, остающихся на старом сервисе для пилота.
// По именам (а не по путям) — чтобы переименование путей не ломало гейт.
const OLD_SERVICE_ROUTES = new Set([
  // /applications/view/* — заявка и все её подстраницы
  'RequestDetail', // view/:id
  'RequestDetailDraft', // view/:id/draft
  'RequestApprove', // view/:id/approve
  'RequestRevoke', // view/:id/revoke
  'PhotoreportDetail', // view/:id/photoreports
  'PhotoreportPhoto', // view/:id/photoreports/photo
  'TaskDetail', // view/:id/tasks/:taskId
  // /common-requests — список, создание, просмотр (но НЕ редактирование)
  'CommonRequestsView', // list
  'CommonRequestCreate', // create
  'CommonRequestDetail', // view/:id
])

function newServiceUrl() {
  return process.env.VUE_APP_NEW_SERVICE_URL || ''
}

// Список пилотных регионов: env VUE_APP_PILOT_REGIONS (id через запятую) или
// дефолт из constants. Читаем в функции — чтобы env-стаб в тестах работал.
function pilotRegionIds() {
  const env = process.env.VUE_APP_PILOT_REGIONS
  if (!env) return PILOT_REGION_IDS
  return env
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean)
}

// Пилот — хотя бы один пилотный регион присутствует среди регионов пользователя
// (me.regions — объект, ключи = id регионов).
function isPilotRegion(me) {
  if (me == null || typeof me.regions !== 'object' || me.regions === null) {
    return false
  }
  return pilotRegionIds().some((id) => id in me.regions)
}

// Сторож: true → редирект на новый сервис выполнен (навигацию нужно отменить);
// false → остаёмся на старом сервисе. Вызывать после ensureAuthenticated().
export function redirectPilotToNewService(to) {
  const base = newServiceUrl()
  if (!base) return false // фича выключена (env не задан)
  const { me } = useAuth()
  if (!isPilotRegion(me.value)) return false
  if (OLD_SERVICE_ROUTES.has(to.name)) return false
  window.location.replace(base)
  return true
}
